import styled from "styled-components";
const ListboxOptionWrapper = styled("div").attrs(
  ({ highlighted, selected }) => ({
    "aria-current": selected ? "true" : "false",
    "aria-selected": highlighted ? "true" : "false",
    role: "option"
  })
)(
  ({ theme }) => ({
    borderRadius: 2,
    cursor: "pointer",
    display: "flex",
    padding: "4px 8px",
    "&:active": {
      backgroundColor: theme.color.gray4
    }
  }),
  ({ highlighted, theme }) => highlighted ? {
    backgroundColor: theme.color.gray3
  } : void 0,
  ({ highlighted, selected, theme }) => selected ? {
    backgroundColor: highlighted ? theme.color.blue2 : theme.color.blue1,
    color: theme.color.blue6,
    "&:active": {
      backgroundColor: theme.color.blue2
    }
  } : void 0,
  ({ indent }) => ({
    paddingLeft: indent ? 16 : void 0
  })
);
const ListboxOptionCheckbox = styled("div")({
  flex: "0 0 auto",
  paddingRight: 8
});
const ListboxOptionInfo = styled("div")({
  color: "rgba(0, 0, 0, 0.45)",
  marginLeft: "auto",
  paddingLeft: 8
});
const ListboxOptionMain = styled("div")({
  flex: "1 1 0",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});
export {
  ListboxOptionCheckbox,
  ListboxOptionInfo,
  ListboxOptionMain,
  ListboxOptionWrapper
};
